"use client";

import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const StandardPage: React.FC<Props> = ({ children, className = '', style }) => {
  return (
    <div className={`relative isolate w-full overflow-x-hidden ${className}`} style={style}>
      <div className="w-full max-w-[1200px] px-2 max-[430px]:px-1 md:px-4 mx-auto">{children}</div>
    </div>
  );
};

export default StandardPage;
